import { render, staticRenderFns } from "./HeaderChallengeDisplay.vue?vue&type=template&id=d8b884a6&scoped=true&"
import script from "./HeaderChallengeDisplay.vue?vue&type=script&lang=js&"
export * from "./HeaderChallengeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./HeaderChallengeDisplay.vue?vue&type=style&index=0&id=d8b884a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b884a6",
  null
  
)

export default component.exports